import { createTheme } from '@mui/material/styles';
export const light = createTheme({
    palette: {
        mode: 'light',
        text: {
            primary: '#212121',
            secondary: '#666666',
            disabled: '#9E9E9E',
            hint: '#9E9E9E'
        },
        actions: {
            main: '#666666',
            background: '#EBEBEB',
            disabledBackground: '#E0E0E0',
            disabledText: '#BDBDBD'
        },
        background: {
            default: '#FFFFFF',
            secondary: '#F5F5F5'
        },
        primary: {
            main: '#4739E7',
            dark: '#2014A3',
            light: '#EDECFD',
            background: '#EDECFD',
            border: '#4739E7',
            contrastText: '#FFFFFF'
        },
        secondary: {
            main: '#AD2BE9',
            dark: '#852494',
            light: '#C75BD7',
            background: '#F7EAFD',
            border: '#DD9CE7',
            contrastText: '#FFFFFF'
        },
        success: {
            main: '#12732F',
            dark: '#3B873E',
            light: '#7BC67E',
            lightBg: '#E8F1EB',
            border: '#A5D6A7',
            contrastText: '#FFFFFF'
        },
        info: {
            main: '#0E71EB',
            dark: '#0B79D0',
            light: '#64B6F7',
            lightBg: '#E7F1FD',
            border: '#8FCAF8',
            contrastText: '#FFFFFF'
        },
        warning: {
            main: '#FF9800',
            dark: '#C77700',
            light: '#FFB547',
            lightBg: '#FFF5E6',
            border: '#FFCB7F',
            contrastText: '#211400'
        },
        error: {
            main: '#EB1414',
            dark: '#CE1212',
            light: '#F88078',
            lightBg: '#FDE8E8',
            border: '#F9A09A',
            contrastText: '#FFFFFF'
        },
        other: {
            stroke: 'rgba(0, 0, 0, 0.23)',
            divider: '#E0E0E0',
            backdrop: 'rgba(0, 0, 0, 0.5)',
            snackbar: '#323232',
            outline: '#FFBA00',
            brandColor: '#4739E7'
        }
    }
});
